/* @ngInject */

export default () => {
  function supplant(_template, _values) {
    return _template.replace(/\{([^{}]*)\}/g, function (a, b) {
      var r = _values[b];
      return typeof r === 'string' || typeof r === 'number' ? r : a;
    });
  }
  var service = {
    supplant: supplant
  };
  return service;
};
